"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.exportCurrencyRates = exportCurrencyRates;
exports.getConversionRate = getConversionRate;
exports.getCurrencyRates = getCurrencyRates;

var _api = _interopRequireWildcard(require("./api"));

var _moment = _interopRequireDefault(require("moment"));

var _tokenStorage = _interopRequireDefault(require("./lib/tokenStorage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Returns conversion rate between the passed currencies on the passed date.
 * E.g. '2018-09-04', USD, EUR will return '0,864342335'
 *
 *
 * @param {Date|string} date date for which to get the rates
 * @param {number} from from which currency the conversion takes place
 * @param {number} to to which currency the conversion takes place
 * @returns {Promise<number>} the rate of the conversion
 */
function getConversionRate(date, from, to) {
  var dateString = (0, _moment["default"])(new Date(date)).format('YYYY-MM-DD');
  return _api["default"].get("/api/currency-rates/conversion-rate?date=".concat(dateString, "&from=").concat(from, "&to=").concat(to)).then(_api.extractData)["catch"](_api.errorHandler);
}

var api = {
  getConversionRate: getConversionRate
};

function getCurrencyRates(month) {
  return _api["default"].get('/api/currency-rates?month=' + month).then(_api.extractData)["catch"](_api.errorHandler);
}

function exportCurrencyRates(month) {
  var token = _tokenStorage["default"].get();

  var url = "/api/currency-rates?month=".concat(month, "&export=true&token=").concat(token);
  window.open(url);
}

var _default = api;
exports["default"] = _default;